import React from 'react';
import { GeckoModalService } from '@geckolabs/gecko-react-ui';
import WebinarModal from '../../components/WebinarModal';

export const WebinarService = {

    openUrl: (url) => {
        try {
            var win = window.open(url, '_blank');
            if (win) win.focus();
        } catch (err) {
            console.log(err);
            window.location.href = url;
        }
    },

    openModal: (url, description, isOnline = false, isPassed = false) => {
        if (url && isOnline && !isPassed) {

            return new GeckoModalService().open(()=> (<WebinarModal url={url} description={description} />));
            
        }
        return null;
    }
};

export default WebinarService;